import React from 'react';

import PropTypes from 'prop-types';

const Availability = (props) => {
    const {
        children,
        mapLink,
    } = props;
    return (
        <div className="availability-wrapper">
            {children}
            <p>
                {mapLink}
            </p>
        </div>
    );
};

Availability.propTypes = {
    children: PropTypes.node,
    mapLink: PropTypes.node,
};

export default Availability;
